import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import Cta from "../../components/cta/cta";
import KeyFeatBanner from "../../assets/images/key-features/key-feat.png";
import salesTriggers from "../../assets/images/key-features/sales-triggers.png";
import orgChart from "../../assets/images/key-features/org-chart.png";
import directDials from "../../assets/images/key-features/directDials.png";
import reportAnalysis from "../../assets/images/key-features/report-analysis.png";
import linkedin from "../../assets/images/product-comparision/LinkedIn.png";
import zoominfo from "../../assets/images/product-comparision/ZoomInfo.png";
import apollo from "../../assets/images/product-comparision/apollo.png";
import rocketReach from "../../assets/images/product-comparision/rocketReach.png";
import lusha from "../../assets/images/product-comparision/lusha.png";
import uplead from "../../assets/images/product-comparision/uplead.png";

const ProductComparisonNewPage = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  const customGap24 = "24px";

  return (
    <>
      <div className="productCom-wrapper">
        <section className="productComBanner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb20 text-color-131415">
                  Why we are the Smartest Choice for <br /> Sales & Marketing
                  Automation
                </h1>
                <p className="heading16px roboto-regular mb30 text-color-131415 max-width950">
                  When it comes to sales and marketing automation, the right
                  tool can be the game-changer your team needs. While other
                  platforms offer fragmented features, BeyondLeadz delivers a
                  powerful, all-in-one solution tailored for modern businesses.
                  From intelligent lead generation to personalized email
                  marketing, our platform doesn’t just keep up with the
                  competition—it outshines it.
                </p>

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Subscribe Now
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <div style={{ height: "60px" }}></div>

        <section style={{ backgroundColor: "#FAFAFF" }}>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Compare the top CRMs
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": customGap24,
                }}
              >
                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={linkedin}
                    alt="BeyondLeadz vs LinkedIn"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">LinkedIn</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    LinkedIn helps with professional networking and prospect
                    discovery, but it lacks advanced sales automation and email
                    marketing tools. BeyondLeadz combines lead generation, email
                    campaigns, and CRM integration in one platform, delivering
                    AI-driven insights and a seamless experience—all at a more
                    affordable price.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={zoominfo}
                    alt="BeyondLeadz vs ZoomInfo"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">ZoomInfo</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    ZoomInfo provides robust contact data but is expensive and
                    requires additional tools for marketing and CRM. Leadhead
                    offers comparable data accuracy with integrated email
                    marketing, advanced automation, and user-friendly tools—all
                    at a fraction of the cost, making it the smarter, more
                    comprehensive choice.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={apollo}
                    alt="BeyondLeadz vs Apollo.io"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">Apollo.io</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    Apollo.io is great for startups but lacks depth for scaling
                    businesses. Leadhead takes the lead with AI-powered
                    automation, superior data accuracy, and scalable features
                    that grow with your needs. With Leadhead, you get a
                    complete, intuitive solution for sales and marketing
                    success.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={rocketReach}
                    alt="BeyondLeadz vs RocketReach"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">RocketReach</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    RocketReach is limited to contact lookup, while Leadhead
                    transforms contacts into actionable leads. With built-in
                    automation, CRM integration, and AI-driven insights,
                    Leadhead offers everything you need to engage, nurture, and
                    convert prospects—making it far more versatile and
                    impactful.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={lusha}
                    alt="BeyondLeadz vs Lusha"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">Lusha</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    Lusha focuses on contact data but doesn’t offer tools to
                    engage or convert leads. Leadhead combines contact
                    enrichment with email marketing, CRM integration, and
                    AI-powered insights, offering an all-in-one platform to
                    streamline your sales and marketing efforts.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow">
                  <img
                    src={uplead}
                    alt="BeyondLeadz vs Uplead"
                    className="img-responsive mb40"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    BeyondLeadz vs{" "}
                    <span className="text-primary-color">Uplead</span>{" "}
                  </h3>
                  <p className="heading16px roboto-regular">
                    UpLead focuses on accurate lead data but lacks advanced
                    sales automation and marketing tools. Leadhead goes beyond
                    just data by combining AI-powered lead scoring, email
                    marketing, and CRM integration in one seamless platform.
                    It’s not just about finding leads—it’s about converting them
                    efficiently and affordably.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h2 className="roboto-bold mb20 heading29px">
                  Why Choose BeyondLeadz?
                </h2>
                <p className="heading16px roboto-regular mb30 text-color-131415 max-width950">
                  BeyondLeadz is your ultimate partner in sales and marketing
                  automation, combining precision, speed, and simplicity in one
                  powerful platform. With AI-driven insights, 95%+ data
                  accuracy, and seamless integration with your favorite tools,
                  BeyondLeadz empowers your team to work smarter, not harder.
                  Unlike competitors, we deliver advanced features like lead
                  scoring, personalized email automation, and real-time
                  analytics at an affordable price. Whether you're a growing
                  startup or an established enterprise, BeyondLeadz adapts to
                  your needs, saving you time and boosting your ROI. Choose
                  BeyondLeadz and turn every lead into a lasting success story.
                </p>
              </div>

              <div className="choose-comparion-grids max-width950">
                <div className="left">
                  <div className="box">
                    <p className="heading49px roboto-regular text-primary-color">
                      95%+
                    </p>
                    <p className="heading16px roboto-regular">
                      Data accuracy ensures high-quality outreach.
                    </p>
                  </div>
                  <div className="box">
                    <p className="heading49px roboto-regular text-primary-color">
                      50M
                    </p>
                    <p className="heading16px roboto-regular">
                      verified contacts in our database.
                    </p>
                  </div>
                  <div className="box">
                    <p className="heading49px roboto-regular text-primary-color">
                      2X
                    </p>
                    <p className="heading16px roboto-regular">
                      growth in ROI for 70% of our customers within the first
                      year.
                    </p>
                  </div>

                  <div className="box">
                    <p className="heading49px roboto-regular text-primary-color">
                      99.9%
                    </p>
                    <p className="heading16px roboto-regular">
                      uptime ensures your tools are always ready to work when
                      you are.
                    </p>
                  </div>
                </div>
                <div className="right">
                  <div className="large-box roboto-regular ">
                    <p className="heading39px text-white mb10">
                      10,000 <br /> businesses
                    </p>
                    <p className="heading20px text-white">
                      Worldwide trust <br /> BeyondLeadz
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default ProductComparisonNewPage;
